<template>
  <div class="bg-white d-flex justify-content-between w-100" :class="containerClass" style="border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); padding: 10px 20px;">
    <div class="d-flex text-start draggable-handle">
      <i class="fas fa-arrows-alt me-5" :style="{color: Theme.gray}"></i>
      <div>{{ label }}</div>
    </div>
    <div class="text-end">
      <i class="fas fa-edit me-5" v-if="$can(abilities.UPDATE_OPPORTUNITY_STATE)" @click="updateItem($event, id)" :style="{color: Theme.gray}"></i>
      <i class="fas fa-trash" v-if="$can(abilities.DELETE_OPPORTUNITY_STATE)" @click="deleteItem($event, id)" :style="{color: Theme.gray}"></i>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { Theme } from '@/composables/theming';
import abilities from "@/composables/abilities";

const emits = defineEmits(['actionUpdate', 'actionDelete'])

const props = defineProps({
  id: String,
  containerClass: String,
  label: String
})

function updateItem(event, id){
  event.preventDefault()
  emits('actionUpdate', id)
}

function deleteItem(event, id){
  event.preventDefault()
  emits('actionDelete', id)
}

</script>

<style scoped>
i {
  font-size: 15px;
}
</style>
